import {Container, SmallView, Text1, Title1, View} from "../../../../styles/business-components";
import * as S from './styles'

import Image from '../../../../assets/images/business/b_m_cnt3_img1.png'

export const Content3 = () => {
    return (
        <Container>
            <View>
                <S.Content>
                    <div>
                        <S.Image src={Image}/>
                    </div>
                    <div>
                        <Title1>Устраивайте онлайн мероприятия для коллег и партнеров</Title1>
                        <Text1>TeleGuard Business - отличный инструмент для онлайн-вебинаров и мероприятий.</Text1>
                        <Text1>С нами вы на связи, независимо от времени и  местоположения.</Text1>
                        <Text1>Повышайте мотивацию на виртуальных встречах и принимайте решения вместе. </Text1>
                    </div>
                </S.Content>
            </View>
            <SmallView>
                <Title1>Устраивайте онлайн мероприятия для коллег и партнеров</Title1>
                <S.SmallContent>
                    <div>
                        <S.Image src={Image}/>
                    </div>
                    <div>
                        <Text1>TeleGuard Business - отличный инструмент для онлайн-вебинаров и мероприятий.</Text1>
                        <Text1>С нами вы на связи, независимо от времени и  местоположения.</Text1>
                    </div>
                </S.SmallContent>
                <Text1>Повышайте мотивацию на виртуальных встречах и принимайте решения вместе. </Text1>
            </SmallView>
        </Container>
    )
}